export default "__VITE_ASSET__PXyiZfU4__"